export const STATUS = {
  editando: ["Editando projeto", "bg-[#E67E22]/15 border-[#E67E22]/50 text-[#E67E22]"],
  enviado: ["Enviado para a central", "bg-sky-500/15 border-sky-500/50 text-sky-400"],
  conferido: ["Conferido — aguardando aprovação", "bg-yellow-500/15 border-yellow-500/50 text-yellow-400"],
  aprovado: ["Aprovado para corte", "bg-[#10B981]/15 border-[#10B981]/50 text-[#10B981]"],
  recusado: ["Recusado pelo cliente", "bg-red-500/15 border-red-500/50 text-red-400"],
  concluido: ["Concluído", "bg-purple-500/15 border-purple-500/50 text-purple-400"],
};

const OLD = { revisado: "conferido", cortado: "concluido" };
export const statusOf = (p) => OLD[p?.status] || p?.status || (p?.completed ? "enviado" : "editando");
export const CLIENT_LOCKED = ["aprovado", "concluido"];

export const StatusBadge = ({ status, testId }) => {
  const [label, cls] = STATUS[status] || STATUS.editando;
  return (
    <span data-testid={testId} data-status={status} className={`inline-block rounded-full border text-[11px] px-2 py-0.5 whitespace-nowrap ${cls}`}>
      {label}
    </span>
  );
};
